import { environment } from '@/helpers/Environment';
import store from '@/store/store';
function isExternalUrlAuth() {
    return Boolean(environment.web.external_urls?.login);
}
function login() {
    const externalUrl = environment.web.external_urls?.login;
    if (externalUrl) {
        const cartId = store.getters['Cart/cartId'];
        window.location.assign(cartId ? `${externalUrl}?cartId=${cartId}` : externalUrl);
        return { success: true };
    }
    return { success: false, error: Error('External login URL missing') };
}
function logout() {
    const externalUrl = environment.web.external_urls?.logout;
    if (externalUrl) {
        window.location.assign(externalUrl);
        return { success: true };
    }
    return { success: false, error: Error('External logout URL missing') };
}
export const externalUrlAuth = {
    isExternalUrlAuth,
    login,
    logout,
};
